import { Box, FormControl, FormHelperText, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Editor as TinyMceEditor } from '@tinymce/tinymce-react';
import Editor, { initConfig } from 'components/common/editor/Editor';
import { useRef } from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { WriteWithAIFormValues } from '../../hooks/useWriteWithAIForm';

type TextEditorProps = {};

function TextEditor({}: TextEditorProps) {
  const {
    control,
    formState: { isSubmitting },
    setValue,
  } = useFormContext<WriteWithAIFormValues>();
  const { text = [] } = useWatch({
    control,
  });
  const editorRef = useRef<TinyMceEditor['editor'] | null>(null);

  return (
    <Box sx={{ mb: 1, position: 'relative' }}>
      <Controller
        control={control}
        render={({ field: { ref, onChange, ...field }, fieldState }) => (
          <FormControl fullWidth>
            <Editor
              {...field}
              onEditorChange={onChange}
              onInit={(_, editor) => {
                ref(editor);
                editorRef.current = editor;
                editor.editorContainer.style.transition = 'height 0.4s';
              }}
              value={!!field?.value?.trim() ? field.value : ''}
              disabled={isSubmitting}
              init={{
                placeholder: 'Copy your text (and images too!), and let our AI rewrite it for you!',
                height: 400,
                min_height: 400,
                max_height: 400,
                auto_focus: true,
                toolbar: false,
                statusbar: false,
                plugins: [...(initConfig()?.plugins || []), 'autoresize'],
              }}
              onBlur={() => {
                field.onBlur();
                setValue(`text.${text.length - 1}.text`, field?.value?.trim());
              }}
            />
            <FormHelperText error>{fieldState.error?.message}</FormHelperText>
          </FormControl>
        )}
        name={`text.${text.length - 1}.text`}
      />
    </Box>
  );
}

const DescriptionPlaceholder = styled(Typography, { label: 'DescriptionPlaceholder' })(
  ({ theme }) => ({
    fontSize: 16,
    fontWeight: 600,
    color: theme.palette.custom.coolGrey,
  }),
);

export default TextEditor;
